type LegalRow = Record<string, any> | null | undefined

export function canGenerateLawAiFields(row: LegalRow, isHmcAdmin: boolean) {
  if (!isHmcAdmin) return false

  const landId = Number(row?.id_Land)
  return landId === 2 || landId === 6 ||
    (landId === 1 && String(row?.pcode ?? '').trim().length > 0)
}

export function hasRequiredLawAiStandardTexts(row: LegalRow) {
  return Number(row?.id_Land) !== 2 || row?.hasStandardtexts === true
}

export function lawAiGenerationPath(row: LegalRow, rechtsgrundlageId: number) {
  const landId = Number(row?.id_Land)
  const action = landId === 1
    ? 'generate_german_ai_fields'
    : landId === 2
      ? 'generate_austrian_ai_fields'
      : 'generate_ai_fields'
  return `/rechtsgrundlagen/${rechtsgrundlageId}/${action}.json`
}
